import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Breadcrumb } from 'antd-v5';
// eslint-disable-next-line max-len
import { DelegateSessionConnectionBoxBody } from 'components/Page/Header/TopHeader/Profile/DelegateSessionConnectionBox/DelegateSessionConnectionBox';
import { getActiveSession } from 'domains/delegation';
import { Flex, Text } from 'UI';

export interface ConnectAsProps {
  onBack: () => void;
}

const ConnectAs = ({ onBack }: ConnectAsProps) => {
  const { t } = useTranslation();
  const activeSession = useSelector(getActiveSession);
  const [selectedSellerTresorCode, setSelectedSellerTresorCode] = useState<string | undefined>(
    activeSession?.delegatedSellerTresorCode,
  );
  const [selectedBuyerTresorCode, setSelectedBuyerTresorCode] = useState<string | undefined>(
    activeSession?.delegatedBuyerTresorCode,
  );
  const [expandSellersSelector, setExpandSellersSelector] = useState(false);
  const [expandBuyersSelector, setExpandBuyersSelector] = useState(false);
  const hasSelectedBuyer = Boolean(selectedBuyerTresorCode);

  return (
    <Flex direction={'column'} gap={17}>
      <Flex align={'center'} minHeight={50} maxHeight={50} padding={'0 24px'}>
        <Breadcrumb
          items={[
            {
              title: (
                <Flex size={0} align={'center'} gap={5}>
                  <Text
                    type={'base'}
                    bold
                    cursor={'pointer'}
                    disableGutter
                    onClick={onBack}
                    color={'neutral_text_tertiary'}
                  >
                    {'<'}
                  </Text>
                  <Text
                    type={'base'}
                    bold
                    cursor={'pointer'}
                    disableGutter
                    onClick={onBack}
                    color={'neutral_text_tertiary'}
                  >
                    {t('common.back', 'Back')}
                  </Text>
                </Flex>
              ),
              onClick: onBack,
            },
            {
              title: (
                <Text type={'base'} cursor={'pointer'} disableGutter>
                  {t('connect_as', 'Connect as')}
                </Text>
              ),
            },
          ]}
        />
      </Flex>
      <Flex direction={'column'} size={0} padding={'0 24px'}>
        <Text type={'heading5'}>{t('connect_as', 'Connect as')}</Text>
        {!hasSelectedBuyer && (
          <Text type={'base'}>
            {t('connect_as.identify_garage.description', 'Identify a garage to log into its workspace.')}
          </Text>
        )}
      </Flex>
      <DelegateSessionConnectionBoxBody
        selectedSellerTresorCode={selectedSellerTresorCode}
        setSelectedSeller={setSelectedSellerTresorCode}
        selectedBuyerTresorCode={selectedBuyerTresorCode}
        setSelectedBuyerTresorCode={setSelectedBuyerTresorCode}
        expandSellersSelector={expandSellersSelector}
        setExpandSellersSelector={setExpandSellersSelector}
        expandBuyersSelector={expandBuyersSelector}
        setExpandBuyersSelector={setExpandBuyersSelector}
        clickable={!activeSession}
        onBack={onBack}
      />
    </Flex>
  );
};

export default ConnectAs;
